declare namespace $ {

	type $mol_button_major__enabled_bog_testops_app_generator_1 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['can_generate'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_bog_testops_app_generator_2 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['generate'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_testops_app_generator_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_select__value_bog_testops_app_generator_4 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['product'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_testops_app_generator_5 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['product_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_form_field__name_bog_testops_app_generator_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_generator_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_select__value_bog_testops_app_generator_8 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['test_type'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_testops_app_generator_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_form_field__name_bog_testops_app_generator_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_generator_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_select__value_bog_testops_app_generator_12 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['priority'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_bog_testops_app_generator_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_form_field__name_bog_testops_app_generator_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_generator_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_textarea__hint_bog_testops_app_generator_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_bog_testops_app_generator_17 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['requirements'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_bog_testops_app_generator_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_generator_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_textarea__hint_bog_testops_app_generator_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_bog_testops_app_generator_21 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['api_spec'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_bog_testops_app_generator_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_generator_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_string__hint_bog_testops_app_generator_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_testops_app_generator_25 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['base_url'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_bog_testops_app_generator_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__content_bog_testops_app_generator_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form_field['content'] >
	>
	type $mol_form__form_fields_bog_testops_app_generator_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_text__text_bog_testops_app_generator_29 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['manual_code'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_card__title_bog_testops_app_generator_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['title'] >
	>
	type $mol_card__content_bog_testops_app_generator_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['content'] >
	>
	type $mol_text__text_bog_testops_app_generator_32 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['automated_code'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_card__title_bog_testops_app_generator_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_card['title'] >
	>
	type $mol_card__content_bog_testops_app_generator_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['content'] >
	>
	type $mol_button_major__click_bog_testops_app_generator_35 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_testops_app_generator_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_minor__click_bog_testops_app_generator_37 = $mol_type_enforce<
		ReturnType< $bog_testops_app_generator['regenerate'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_testops_app_generator_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_row__sub_bog_testops_app_generator_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_deck__items_bog_testops_app_generator_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_deck['items'] >
	>
	export class $bog_testops_app_generator extends $mol_page {
		can_generate( ): boolean
		generate( next?: any ): any
		generate_label( ): string
		Generate_btn( ): $mol_button_major
		product( next?: string ): string
		product_options( ): readonly(any)[]
		Product( ): $mol_select
		Product_field( ): $mol_form_field
		test_type( next?: string ): string
		TestType( ): $mol_select
		TestType_field( ): $mol_form_field
		priority( next?: string ): string
		Priority( ): $mol_select
		Priority_field( ): $mol_form_field
		requirements( next?: string ): string
		Requirements( ): $mol_textarea
		Requirements_field( ): $mol_form_field
		api_spec( next?: string ): string
		ApiSpec( ): $mol_textarea
		ApiSpec_field( ): $mol_form_field
		base_url( next?: string ): string
		BaseUrl( ): $mol_string
		BaseUrl_field( ): $mol_form_field
		Form( ): $mol_form
		manual_code( ): string
		Manual_code( ): $mol_text
		Manual_code_card( ): $mol_card
		automated_code( ): string
		Automated_code( ): $mol_text
		Automated_code_card( ): $mol_card
		save( next?: any ): any
		save_label( ): string
		Save_btn( ): $mol_button_major
		regenerate( next?: any ): any
		regenerate_label( ): string
		Regenerate_btn( ): $mol_button_minor
		SaveRow( ): $mol_row
		ResultCard( ): $mol_deck
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=generator.view.tree.d.ts.map